module.exports = __webpack_public_path__ + "img/s-bjx-details-top.f274ef9f.jpg";